// src/redux/features/imageApi.ts

import { api } from '../services/api';
import { imageURL } from '../../components/Data/baseURL';

export interface ImageResponse {
  s3_url: string;
}

export const imageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getImage: builder.query<ImageResponse, string>({
      query: (uniqueField) => ({
        url: imageURL,
        method: 'GET',
        params: {
          unique_field: uniqueField,
        },
      }),

      providesTags: (_result, _error, uniqueField) => [
        {
          type: 'Image',
          id: uniqueField,
        },
      ],
    }),
  }),
});

export const { useGetImageQuery, useLazyGetImageQuery } = imageApi;
